import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiOutlinedInput: {
            defaultProps: {
                notched: false,
                size: 'small',
            },
            styleOverrides: {
                root: {
                    backgroundColor: designTokens.color.shade.white.value,
                    borderRadius: theme.spacing(0.5),
                    marginTop: theme.spacing(0.5),
                    '&.MuiInputBase-multiline': {
                        padding: 0,
                    },
                    '& > fieldset.MuiOutlinedInput-notchedOutline': {
                        borderColor: designTokens.color.gray.limestone.value,
                    },
                    ':hover': {
                        '& > fieldset.MuiOutlinedInput-notchedOutline': {
                            borderColor: designTokens.color.gray.limestone.value,
                        },
                    },
                    '&.Mui-error': {
                        '& > fieldset.MuiOutlinedInput-notchedOutline': {
                            borderColor: designTokens.color.status.error.value,
                        },
                        '&.Mui-focused': {
                            '& > fieldset.MuiOutlinedInput-notchedOutline': {
                                borderColor: designTokens.color.status.error.value,
                            },
                        },
                    },
                    '&.Mui-focused': {
                        '& > fieldset.MuiOutlinedInput-notchedOutline': {
                            borderColor: designTokens.color.secondary.default.value,
                            borderWidth: theme.spacing(0.125),
                        },
                    },
                    '&.Mui-disabled': {
                        backgroundColor: designTokens.color.gray.light.value,
                        '& > fieldset.MuiOutlinedInput-notchedOutline': {
                            borderColor: designTokens.color.gray.disabled.value,
                        },
                    },
                },
                input: {
                    padding: theme.spacing(1.25, 1.5),
                    fontSize: designTokens.typography.body.long1.size.value,
                    lineHeight: designTokens.typography.body.long1.lineHeight.value,
                    '::placeholder': {
                        color: designTokens.color.gray.disabled.value,
                        opacity: 1,
                    },
                    '&.Mui-disabled': {
                        '::placeholder': {
                            webkitTextFillColor: designTokens.color.gray.disabled.value,
                        },
                    },
                },
                multiline: {},
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=outlinedInputTheme.js.map